import React from 'react'
import LabeledValue from '../../../../components/common/LabeledValue'
import RightPanel from './RightPanel'
import CurrentRequestSection from './CurrentRequestSection'
import HistorySection from './HistorySection'
import { TimeOffRequestDetails, isVacationBid } from '../../../../store/slices/Requestor/timeOffDetailsSlice'
import { getVacationBidAwareTableProps } from './vacationBidOverlapDisplay'

interface Props {
  data: TimeOffRequestDetails
  tableRows: any[]
  highlightedDates: string[]
  handlePrint: () => void
}

const PartiallyApprovedRetractionDeniedView: React.FC<Props> = ({
  data,
  tableRows,
  highlightedDates,
  handlePrint,
}) => {
  return (
    <>
      <h1 className="h1">Time Off Request Retraction Denied</h1>

      <div className="flex flex-col mobile:gap-4 tablet:gap-6 desktop:gap-8 desktop:flex-row items-start">
        <div className="flex-1">
          {data.deniedOn && (
            <div className="mb-4">
              <LabeledValue
                label="Retraction Denied On"
                value={data.deniedOn}
              />
            </div>
          )}

          {data.authorizedApprover && (
            <div className="mb-4">
              <LabeledValue
                label="Authorized Approver"
                value={data.authorizedApprover}
              />
            </div>
          )}

          {data.denialReason && (
            <div className="mb-4">
              <LabeledValue label="Denial Reason" value={data.denialReason} />
            </div>
          )}
          <div className="mb-4">
            <LabeledValue
              label="Approver Comments"
              value={data.approverComments || '-'}
            />
          </div>
        </div>

        <RightPanel data={data} handlePrint={handlePrint} />
      </div>

      <div className="mt-6!">
        <hr className="-variation-1" />
      </div>

      {data.history && data.history.length > 0 && (
        <HistorySection history={data.history} />
      )}

      <CurrentRequestSection
        {...getVacationBidAwareTableProps(tableRows, isVacationBid(data))}
        highlightedDates={highlightedDates}
      />
    </>
  )
}

export default PartiallyApprovedRetractionDeniedView